/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm} from '@insticator/insticator-ui';


/* ++++++++++ --------------- GENERAL CONFIGS - SENTIMENT CONFIGS : STYLES --------------- ++++++++++ */
export default {
  generalconfig: {
    '& .inline': {
      display: 'inline-block',
      paddingRight: '0.7em',
    },
    '& .field': {
      width: '100%',
      maxWidth: pxToEm(650)
    }
  }
};
